export default {
  account_type: 'Account Type',
  category: 'Category',
  code: 'Code',
  confirm_password: 'Confirm Password',
  discount_amount: 'Discount Amount',
  discount_description: 'Discount Description',
  discount_method: 'Discount Method',
  due_date: 'Due Date',
  full_name: 'Full Name',
  gender: 'Gender',
  id: 'Identity ID',
  identity_type: 'Identity Type',
  invoice_date: 'Invoice Date',
  name: 'Name',
  nationality: 'Nationality',
  password: 'Password',
  remark: 'Remark',
  role: 'Role',
  username: 'Username',
  amount_receive: 'Amount Received',
  amount: 'Amaun',
  customer_name: 'Nama Pelanggan',
  total_no_of_people: 'Jumlah Pelanggan',
  total_no_of_days: 'Jumlah Dhari',
  start_date: 'Tarikh Mula',
  end_date: 'Tarikh Akhir',
  license_no: 'No Akaun / No Lesen',
  email_address: 'Email Address'
}
